/*
 * @Author: wanxiaodong
 * @Date: 2019-12-31 17:30:12
 * @Last Modified by: wanxiaodong
 * @Last Modified time: 2020-01-03 17:36:01
 * @Description:
 */
import React from 'react'
import {useSearchParams} from 'react-router-dom'
import ContentBlock from './content-block/index'
import MailMask from './mail-mask'
import ContentType, {TextInter, TextArrayInter, ImgInter, BaseInter, BlockInter} from '../types/content'
interface Props{
    blockInfo: BlockInter,
    children?: any
}
export default function InfoBlock(props: Props) {
    const [searchParams] = useSearchParams()
    const location = {search: '?' + searchParams.toString()}

    if (props.blockInfo.type === ContentType.Mask) {
        return <MailMask blockInfo={props.blockInfo} location={location}></MailMask>
    }
    return (<div className='info-block-container'>
        <div>
            <h2 className='title'>{props.blockInfo.title} <span className='sub-title'>{props.blockInfo.subTitle}</span></h2>
        </div>
        <div>
            <ContentBlock content={props.blockInfo}/>
        </div>
    </div>)
}